const url = '/api/v1/gradebook/';

/**
 * @description cleanup and set new state for homework chunks
 * @param { Object } lessonResult object from API
 */
const fillerLocalStorage = (lessonResult, debug = false) => {
    if(debug) {
        console.log("fillerLocalStorage", lessonResult);
    }

    return new Promise((resolve) => {
        if (lessonResult.test && lessonResult.testData.scorms) {
            for (let i in lessonResult.testData.scorms) {
                if (lessonResult.testData.scorms[i].progress) {
                    localStorage.removeItem(
                        lessonResult.testData.scorms[i].progress.key
                    );
                    localStorage.setItem(
                        lessonResult.testData.scorms[i].progress.key,
                        lessonResult.testData.scorms[i].progress.value
                    );
                }
            }
        }

        if (lessonResult.tabs && lessonResult.tabs.homework.chunks) {
            for (let iChunk in lessonResult.tabs.homework.chunks) {
                for (let iScorm in lessonResult.tabs.homework.chunks[iChunk]
                    .scorms) {
                    if (
                        lessonResult.tabs.homework.chunks[iChunk].scorms[iScorm]
                            .progress
                    ) {
                        localStorage.removeItem(
                            lessonResult.tabs.homework.chunks[iChunk].scorms[
                                iScorm
                            ].progress.key
                        );
                        localStorage.setItem(
                            lessonResult.tabs.homework.chunks[iChunk].scorms[
                                iScorm
                            ].progress.key,
                            lessonResult.tabs.homework.chunks[iChunk].scorms[
                                iScorm
                            ].progress.value
                        );
                    }
                }
            }
        }

        resolve();
    })
}

export const state = {
    modalLessonResult: false,
    lessonResult: {},
    lesson_id: {},
    student_id: {},
}

export const getters = {
    modalLessonResult: state => state.modalLessonResult,
    lessonResult: state => state.lessonResult,
    lesson_id: state => state.lesson_id,
    student_id: state => state.student_id,
}

export const mutations = {
    setData(state, {type, items}) {
        state[type] = items;
    },

    clearData(state, {types}) {
        for (let key in state) {
            for (let type in types) {
                key === types[type] ? state[key] = null : false
            }
        }
    }
}

export const actions = {
    async showModalLessonResult({ commit, dispatch }, { lesson_id, student_id }) {
        dispatch('loading/addLoading', '', { root: true })
        commit('setData', {type: 'lesson_id', items: lesson_id});
        commit('setData', {type: 'student_id', items: student_id});
        await dispatch('getLessonResult')
        commit('setData', {type: 'modalLessonResult', items: true});
        dispatch('loading/subLoading', '', { root: true })
    },

    async getLessonResult({ commit, state, dispatch }) {
        dispatch('loading/addLoading', '', { root: true })

        try {
            const { data } = await axios.get(url + 'lesson-result/' + state.lesson_id + '/' + state.student_id);

            await fillerLocalStorage(data)

            commit('setData', { type: 'lessonResult', items: data });
        } catch (error) {
            console.log(error)
        }

        dispatch('loading/subLoading', '', { root: true })
    },

    async changeScormTask({ dispatch }, params){
        try {
            dispatch('loading/addLoading', '', { root: true })
            await axios.post(url + 'change-scorm-task', params);
            await dispatch('getLessonResult')
            dispatch('loading/subLoading', '', { root: true })
            return Promise.resolve();
        } catch (e) {
            return Promise.reject();
        }
    },

    async changeScore({ dispatch }, params){
        try {
            dispatch('loading/addLoading', '', { root: true })
            await axios.post(url + 'change-score', params);
            dispatch('loading/subLoading', '', { root: true })
            return Promise.resolve();
        } catch (e) {
            return Promise.reject();
        }
    },

    async changeDictaphoneResult({ dispatch }, params){
        try {
            dispatch('loading/addLoading', '', { root: true })
            await axios.post(url + 'change-dictaphone-result', params);
            await dispatch('getLessonResult')
            dispatch('loading/subLoading', '', { root: true })
            return Promise.resolve();
        } catch (e) {
            return Promise.reject();
        }
    },

    async changeStudentFileScore({ dispatch }, params){
        try {
            dispatch('loading/addLoading', '', { root: true })
            await axios.post(url + 'change-student-file-result', params);
            await dispatch('getLessonResult')
            dispatch('loading/subLoading', '', { root: true })
            return Promise.resolve();
        } catch (e) {
            return Promise.reject();
        }
    },

    async changeOverAllScore({ dispatch }, params){
        try {
            dispatch('loading/addLoading', '', { root: true })
            await axios.post(url + 'change-overall-grade-score', params);
            // await dispatch('getLessonResult')
            dispatch('loading/subLoading', '', { root: true })
            return Promise.resolve();
        } catch (e) {
            return Promise.reject();
        }
    },

    hideModal({ commit }, modal) {
        localStorage.clear();
        commit('setData', { type: modal, items: false });
    },
    // end modals
};
